import React from 'react';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import './ProgramTimeline.css';

export const PROGRAM_WINDOW_LABELS = {
  hier: 'Yesterday',
  aujourd_hui: 'Today',
  demain: 'Tomorrow',
  apres_demain: 'In 2 days',
};

export const PROGRAM_WINDOW_OFFSETS = [-1, 0, 1, 2];

export const programWindowStatusLabel = (day) => {
  if (!day) return '';
  if (day.status === 'completed') return 'Done';
  return 'Available';
};

export const selectedWindowDay = (days, selectedOffset = 0) =>
  (days || []).find((day) => day.offset === selectedOffset) || null;

const ProgramTimeline = ({
  days = [],
  selectedOffset = 0,
  onSelect,
  disabled = false,
}) => {
  const slots = PROGRAM_WINDOW_OFFSETS.map((offset) => ({
    offset,
    day: (days || []).find((item) => item.offset === offset) || null,
  }));

  return (
    <nav className="program-timeline" aria-label="Daily program">
      <span className="program-timeline-arrow" aria-hidden="true">
        <FiChevronLeft />
      </span>
      <div className="program-timeline-slots">
        {slots.map(({ offset, day }) => {
          const isSelected = selectedOffset === offset;
          const isDisabled = disabled || !day;
          const label =
            PROGRAM_WINDOW_LABELS[day?.label] ||
            PROGRAM_WINDOW_LABELS[
              { '-1': 'hier', 0: 'aujourd_hui', 1: 'demain', 2: 'apres_demain' }[
                String(offset)
              ]
            ];
          return (
            <button
              key={offset}
              type="button"
              className={`program-timeline-slot ${isSelected ? 'is-selected' : ''} ${
                day?.status === 'completed' ? 'is-completed' : ''
              } ${day && day.required === false && day.status !== 'completed' ? 'is-optional' : ''}`}
              disabled={isDisabled}
              onClick={() => day && onSelect?.(offset, day)}
            >
              <span className="program-timeline-label">{label}</span>
              {day ? (
                <span className="program-timeline-status">
                  {programWindowStatusLabel(day)}
                </span>
              ) : (
                <span className="program-timeline-status is-empty">—</span>
              )}
            </button>
          );
        })}
      </div>
      <span className="program-timeline-arrow" aria-hidden="true">
        <FiChevronRight />
      </span>
    </nav>
  );
};

export default ProgramTimeline;
